export const CREATE_DEFICIENCY_FIELDS = Object.freeze({
  IMO_NO: "imoNo",
  REGISTERED_VESSEL_ID: "registeredVesselId",
  VESSEL_NAME: "vesselName",
  SHIPPING_AGENCY: "shippingAgency",
  TRIP_NO_PLDA: "tripNoPlda",
  BERTH_VISITED: "berthVisited",
  LOA: "loa",
  DEFICIENCY_DETAILS: "deficiencyDetails",
  REMARKS: "remarks",
  ATTACHMENTS: "attachments",
});

export const FOTT_BERTH_FROM_TO_LOCATION = "FOTT";
export const MAX_DEFICIENCY_ATTACHMENTS = 20;
export const MAX_DEFICIENCY_IMO_DIGITS = 7;
export const MAX_TRIP_NO_PLDA_LENGTH = 10;
export const MAX_DEFICIENCY_DETAILS_LENGTH = 1000;
export const MAX_DEFICIENCY_REMARKS_LENGTH = 1000;
